// @general/notifications - frontend surface.

export { useNotificationStore } from './store'
export { default as NotificationBell } from './components/NotificationBell.vue'

// El tercer canal, para la pantalla que lo enciende. Todo devuelve un estado y
// nada lanza: un navegador sin soporte y una persona que dijo que no son casos
// normales, no errores.
export {
  pushSupported, pushPermission, pushConfig, pushSubscribed, enablePush, disablePush,
  releasePushOnSignOut,
} from './push'

export const routes = [
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('./views/NotificationsView.vue'),
    meta: { title: 'notifications.title' },
  },
]

export default { routes }
